import React, { useContext, useEffect, useRef } from "react";
import "./Sidebar.scss";
import {
  AwardFill,
  ChatDotsFill,
  ClockFill,
  EyeFill,
  ClockHistory,
  HouseDoorFill,
  CollectionPlayFill,
  Sliders
} from "react-bootstrap-icons";
import { Link, NavLink, withRouter } from "react-router-dom";
import { UserContext } from "../../api/user/userContext";
import { Button } from "react-bootstrap";
import opencardsLogo from "../../assets/opencards-logo.png";
import logo from "../../assets/xeester-sidebar-icon.png";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import { SidebarContext } from "../../api/sidebar/SidebarContext";
import { Avatars, EmotIcons, slug } from "../../api/ReplayVariables";
import { isTablet } from "react-device-detect";
import { isMobile } from "react-device-detect";

function Sidebar({ match, location }) {
  const { sidebar, dispatchSidebar } = useContext(SidebarContext);
  const { user } = useContext(UserContext);
  const { t } = useTranslation();

  const scrollbarRef = useRef();
  const _scrollbarRef = React.createRef();

  const toggleOpen = () => {
    //console.log("toggle", sidebar.open);
    dispatchSidebar({ type: "toggle" });
  };

  useEffect(() => {
    const getMargin = () => {
      let margin = 52;
      if (
        isMobile &&
        !isTablet &&
        window.matchMedia &&
        window.matchMedia("(orientation: landscape)").matches
      ) {
        margin = 0;
      }
      return margin;
    };
    const scrollListener = (evt) => {
      //console.log("scrolling", evt);
      evt.target.style.height = window.innerHeight - getMargin() + "px";
    };
    const resizeListener = (evt) => {
      _scrollbarRef.current.updateScroll();
      scrollbarRef.current.style.height = window.innerHeight - 52 + "px";
      dispatchSidebar({ type: "close" });
    };
    window.addEventListener("resize", resizeListener);

    scrollbarRef.current.style.height = window.innerHeight - 52 + "px";
    let scrolls = document.getElementsByClassName("main-scroll");
    for (let k = 0; k < scrolls.length; k++) {
      scrolls[k].style.height = window.innerHeight - getMargin() + "px";
      scrolls[k].addEventListener("scroll", scrollListener);
    }

    return () => {
      window.removeEventListener("resize", resizeListener);
      for (let k = 0; k < scrolls.length; k++) {
        scrolls[k].removeEventListener("scroll", scrollListener);
      }
    };
  }, [sidebar, _scrollbarRef, dispatchSidebar]);

  return (
    <>
      <div
        className={"sidebar-backdrop " + (sidebar.open ? "open" : "")}
        onClick={toggleOpen}
      ></div>
      <div className={"sidebar " + (sidebar.open ? "open" : "")}>
        <div className="header">
          <Button className="custom-toggler" type="button" onClick={toggleOpen}>
            <span className="navbar-toggler-icon"></span>
          </Button>
          <Link data-tip={t("home")} data-for="app-tooltip" to="/">
            <img id="opencards-logo" src={opencardsLogo} alt="Opencards logo" />
          </Link>
        </div>
        <PerfectScrollbar
          ref={_scrollbarRef}
          containerRef={(el) => (scrollbarRef.current = el)}
          className="sidebar-scroll"
          onClick={toggleOpen}
        >
          <div className="menus">
            <NavLink to="/home" className="separator" exact={true}>
              <HouseDoorFill size={92} />
              <div>{t("navigation.home")}</div>
            </NavLink>
            {user !== null && user.error !== 401 ? (
              <>
                <NavLink to={"/c/" + slug(user.username) + "-" + user.id}>
                  <CollectionPlayFill />
                  <div>{t("navigation.myReplays")}</div>
                </NavLink>
                <NavLink to="/history" exact={true}>
                  <ClockHistory />
                  <div>{t("navigation.history")}</div>
                </NavLink>
                <NavLink className="settings-link" to="/settings">
                  <Sliders />
                  <div>{t("navigation.settings")}</div>
                </NavLink>
              </>
            ) : (
              <></>
            )}
            <section>
              <span className="section-icon">
                {t("navigation.rankings.icon")}
              </span>
              <span className="section-title">
                {t("navigation.rankings.title")}
              </span>
            </section>
            <NavLink to="/replays/" exact>
              <ClockFill />
              <div>{t("navigation.rankings.last")}</div>
            </NavLink>
            <NavLink to="/replays/viewed/">
              <EyeFill />
              <div>{t("navigation.rankings.viewed")}</div>
            </NavLink>
            <NavLink to="/replays/commented/">
              <ChatDotsFill />
              <div>{t("navigation.rankings.commented")}</div>
            </NavLink>
            <NavLink to="/replays/voted/" className="separator">
              <AwardFill />
              <div>{t("navigation.rankings.voted")}</div>
            </NavLink>
            <section>
              <span className="section-icon">{t("replayApp.votes.icon")}</span>
              <span className="section-title">
                {t("replayApp.votes.title")}
              </span>
            </section>
            <NavLink to="/replays/vote1/" className="vote-icon">
              <img src={EmotIcons.VOTE1} alt="" />
              <div>{t("replayApp.votes.1")}</div>
            </NavLink>
            <NavLink to="/replays/vote2/" className="vote-icon">
              <img src={EmotIcons.VOTE2} alt="" />
              <div>{t("replayApp.votes.2")}</div>
            </NavLink>
            <NavLink to="/replays/vote3/" className="vote-icon">
              <img src={EmotIcons.VOTE3} alt="" />
              <div>{t("replayApp.votes.3")}</div>
            </NavLink>
            <NavLink to="/replays/vote4/" className="vote-icon separator">
              <img src={EmotIcons.VOTE4} alt="" />
              <div>{t("replayApp.votes.4")}</div>
            </NavLink>
            <section>
              <span className="section-icon">
                {t("navigation.subscriptions.icon")}
              </span>
              <span className="section-title">
                {t("navigation.subscriptions.title")}
              </span>
            </section>
            {user !== null &&
            user.error !== 401 &&
            user.subscriptions !== null ? (
              user.subscriptions.map((subscription) => (
                <NavLink
                  key={subscription.id}
                  to={
                    "/c/" +
                    slug(subscription.username) +
                    "-" +
                    subscription.user_id +
                    "/home"
                  }
                  className="vote-subscription"
                >
                  {subscription.avatar ? (
                    <img
                      className="avatar-image"
                      src={
                        window.serverUrl+"/media/kunena/avatars/" +
                        subscription.avatar
                      }
                      alt="avatar"
                    />
                  ) : (
                    <img
                      className="avatar"
                      src={
                        Avatars[
                          "avatar" +
                            subscription.username.substring(0, 1).toUpperCase()
                        ]
                      }
                      alt=""
                    />
                  )}
                  <div>{subscription.username}</div>
                </NavLink>
              ))
            ) : (
              <></>
            )}
            <section />
            <Button
              href="/"
              className="goto"
              target="_blank"
            >
              <img src={logo} alt="" />
              <div>{t("gotoXeester")}</div>
            </Button>
            <div className="disclaimer">{t("disclaimer").replace("[DATE]", new Date().getFullYear())}</div>
          </div>
        </PerfectScrollbar>
      </div>
    </>
  );
}
export default withRouter(Sidebar);
